import * as c from './constants';

export function initializeSectionTable(key) {
  return { type: c.SECTION_TABLE_INITIALIZE, key };
}

export function destroySectionTable(key) {
  return { type: c.SECTION_TABLE_DESTROY, key };
}

export function setSectionTableData(key, data) {
  return { type: c.SECTION_TABLE_SET_DATA, key, payload: data };
}

export function setSectionTableLoader(key, loading) {
  return { type: c.SECTION_TABLE_SET_LOADER, key, payload: loading };
}

export function setSectionTableError(key, isError, message) {
  return { type: c.SECTION_TABLE_SET_ERROR, key, payload: { isError, message } };
}